import React from "react";
import styles from "./select.module.css";
import RedeemUtil from "@/Core/Redeem/RedeemUtil";

type RedeemListProps = {
    data: ResponseRedeemConfigData,
    callClick: (data: ResponseRedeemConfigData) => void
}

const RedeemSelectItem: React.FC<RedeemListProps> = (props) => {
    const {data,callClick} = props;

    const getOutImgName = () => {
        return `img_out_${RedeemUtil.getChannelTypeName(data.channelType)}`;
    }

    const onItemClick = () => {
        callClick(data);
    }
    return (
        <section className={`${styles.out_item} btn`} onClick={onItemClick}>
            <img src={`/img/redeem/${getOutImgName()}.webp`} alt={getOutImgName()}/>
        </section>
    )
}

export default RedeemSelectItem;